<template>
  <div class="app__text">
    <div class="app__diamond app__diamond--top app__diamond--green"></div>
    <Close />
    <div class="app__textWrapper">
      <div class="app__textContent" v-html="step.content"></div>
      <div class="app__textButton">
        <button class="btn btn__primary w-100" @click="nextStep()">{{step.button}}</button>
      </div>
    </div>
    <div class="app__diamond app__diamond--bottom app__diamond--red"></div>
  </div>
</template>

<script>
import EventBus from "../../event-bus.js";
import Close from "./../Parts/Close.vue";

export default {
  props: ['step', 'currentStep'],
  components: {
    Close
  },
  data: () => ({
    active: false
  }),
  methods: {
    nextStep() {
      EventBus.$emit('SET_STEP', this.currentStep + 1);
    }
  }
}
</script>
